// load-more.js
(function() {
  'use strict';

  class LoadMore {
    constructor() {
      console.log('🔄 LoadMore: Initializing...');
      
      this.loadMoreBtn = document.querySelector('#load-more-btn');
      this.loadingIndicator = document.querySelector('#load-more-loading');
      this.productGrid = document.querySelector('#product-grid');
      this.currentPage = 1;
      this.isLoading = false;
      
      console.log('🔍 LoadMore: Elements found:', {
        loadMoreBtn: !!this.loadMoreBtn,
        loadingIndicator: !!this.loadingIndicator,
        productGrid: !!this.productGrid
      });
      
      if (this.loadMoreBtn) {
        console.log('✅ LoadMore: Button found, initializing...');
        console.log('📋 Button attributes:', {
          nextUrl: this.loadMoreBtn.getAttribute('data-next-url'),
          collectionHandle: this.loadMoreBtn.getAttribute('data-collection-handle'),
          sectionId: this.loadMoreBtn.getAttribute('data-section-id')
        });
        this.init();
      } else {
        console.log('❌ LoadMore: Button not found on page');
      }
    }
    
    init() {
      console.log('🚀 LoadMore: Adding click event listener');
      this.loadMoreBtn.addEventListener('click', this.handleLoadMore.bind(this));
    }
    
    async handleLoadMore(event) {
      console.log('🖱️ LoadMore: Button clicked!');
      
      if (this.isLoading) {
        console.log('⏳ LoadMore: Already loading, ignoring click');
        return;
      }
      
      event.preventDefault();
      
      this.isLoading = true;
      this.showLoading();
      
      try {
        const nextUrl = this.loadMoreBtn.getAttribute('data-next-url');
        const collectionHandle = this.loadMoreBtn.getAttribute('data-collection-handle');
        const sectionId = this.loadMoreBtn.getAttribute('data-section-id');
        
        console.log('📡 LoadMore: Preparing request with:', {
          nextUrl,
          collectionHandle,
          sectionId
        });
        
        // Create the section rendering URL for the next page
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.append('sections', sectionId);
        
        console.log('🌐 LoadMore: Final URL:', url.toString());
        
        const response = await fetch(url.toString());
        
        console.log('📥 LoadMore: Response received:', {
          ok: response.ok,
          status: response.status,
          statusText: response.statusText
        });
        
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
        }
        
        const data = await response.json();
        console.log('📊 LoadMore: Response data:', data);
        
        const sectionHtml = data[sectionId];
        console.log('🏗️ LoadMore: Section HTML found:', !!sectionHtml);
        
        if (sectionHtml) {
          // Create a temporary container to parse the HTML
          const tempContainer = document.createElement('div');
          tempContainer.innerHTML = sectionHtml;
          
          console.log('🔍 LoadMore: Parsing response HTML...');
          
          // Extract the new products from the response
          const newProductsList = tempContainer.querySelector('#product-grid');
          const newLoadMoreSection = tempContainer.querySelector('.load-more');
          
          console.log('🛍️ LoadMore: Found elements in response:', {
            newProductsList: !!newProductsList,
            newProductsCount: newProductsList ? newProductsList.children.length : 0,
            newLoadMoreSection: !!newLoadMoreSection
          });
          
          if (newProductsList && newProductsList.children.length > 0) {
            console.log(`➕ LoadMore: Adding ${newProductsList.children.length} new products`);
            
            // Append new products to existing grid
            Array.from(newProductsList.children).forEach((product, index) => {
              console.log(`📦 LoadMore: Adding product ${index + 1}`);
              this.productGrid.appendChild(product.cloneNode(true));
            });
            
            console.log('🔄 LoadMore: Updating load more button...');
            // Update the load more button or hide it if no more pages
            this.updateLoadMoreButton(tempContainer, newLoadMoreSection);
            
            // Trigger any necessary reinitialization for new products
            this.reinitializeComponents();
          } else {
            console.log('🚫 LoadMore: No new products found, hiding button');
            this.hideLoadMore();
          }
        } else {
          console.log('❌ LoadMore: No section HTML found in response');
          this.hideLoadMore();
        }
      } catch (error) {
        console.error('💥 LoadMore: Error occurred:', error);
        this.showError();
      } finally {
        this.isLoading = false;
        this.hideLoading();
        console.log('✅ LoadMore: Request completed');
      }
    }
    
    updateLoadMoreButton(tempContainer, newLoadMoreSection) {
      console.log('🔄 LoadMore: Updating button state...');
      
      const newLoadMoreBtn = tempContainer.querySelector('#load-more-btn');
      
      console.log('🔍 LoadMore: Found new button in response:', !!newLoadMoreBtn);
      
      if (newLoadMoreBtn && newLoadMoreSection) {
        // Update the next URL for the button
        const newNextUrl = newLoadMoreBtn.getAttribute('data-next-url');
        
        console.log('🔗 LoadMore: New next URL:', newNextUrl);
        
        if (newNextUrl) {
          this.loadMoreBtn.setAttribute('data-next-url', newNextUrl);
          this.currentPage++;
          console.log(`📄 LoadMore: Updated to page ${this.currentPage}`);
        } else {
          console.log('🏁 LoadMore: No more pages available');
          this.hideLoadMore();
        }
      } else {
        console.log('🚫 LoadMore: No load more button found in response, hiding current button');
        this.hideLoadMore();
      }
    }
    
    showLoading() {
      console.log('⏳ LoadMore: Showing loading state');
      this.loadMoreBtn.style.display = 'none';
      if (this.loadingIndicator) {
        this.loadingIndicator.style.display = 'block';
        this.loadingIndicator.classList.remove('hidden');
      }
    }
    
    hideLoading() {
      console.log('✅ LoadMore: Hiding loading state');
      if (this.loadingIndicator) {
        this.loadingIndicator.style.display = 'none';
        this.loadingIndicator.classList.add('hidden');
      }
      
      if (!this.loadMoreBtn.classList.contains('hidden')) {
        this.loadMoreBtn.style.display = 'inline-block';
      }
    }
    
    hideLoadMore() {
      console.log('🔚 LoadMore: Hiding load more button permanently');
      this.loadMoreBtn.style.display = 'none';
      this.loadMoreBtn.classList.add('hidden');
      
      // Optionally show an "end of products" message
      const endMessage = document.createElement('div');
      endMessage.className = 'text-center text-scheme-text pt-4';
      endMessage.textContent = 'No more products to load';
      
      const loadMoreContainer = this.loadMoreBtn.closest('.load-more');
      if (loadMoreContainer) {
        loadMoreContainer.appendChild(endMessage);
        console.log('📝 LoadMore: Added end message');
      }
    }
    
    showError() {
      const errorMessage = document.createElement('div');
      errorMessage.className = 'text-center text-red-500 pt-4';
      errorMessage.textContent = 'Error loading products. Please try again.';
      
      const loadMoreContainer = this.loadMoreBtn.closest('.load-more');
      if (loadMoreContainer) {
        loadMoreContainer.appendChild(errorMessage);
      }
      
      // Re-show the button after a delay
      setTimeout(() => {
        if (errorMessage.parentNode) {
          errorMessage.parentNode.removeChild(errorMessage);
        }
        this.loadMoreBtn.style.display = 'inline-block';
      }, 3000);
    }
    
    reinitializeComponents() {
      // Reinitialize any components that need to be aware of new products
      
      // If using quick buy functionality
      if (window.ProductQuickBuy) {
        const newQuickBuyBtns = this.productGrid.querySelectorAll('[data-quick-buy]:not([data-initialized])');
        newQuickBuyBtns.forEach(btn => {
          new window.ProductQuickBuy(btn);
          btn.setAttribute('data-initialized', 'true');
        });
      }
      
      // If using wishlist functionality
      if (window.Wishlist) {
        const newWishlistBtns = this.productGrid.querySelectorAll('[data-wishlist]:not([data-initialized])');
        newWishlistBtns.forEach(btn => {
          new window.Wishlist(btn);
          btn.setAttribute('data-initialized', 'true');
        });
      }
      
      // Reinitialize any Alpine.js components for new products
      if (window.Alpine) {
        window.Alpine.initTree(this.productGrid);
      }
      
      // Trigger custom event for other components to listen to
      document.dispatchEvent(new CustomEvent('productsLoaded', {
        detail: { container: this.productGrid }
      }));
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    new LoadMore();
  });

  // Also initialize for theme editor updates
  document.addEventListener('shopify:section:load', () => {
    new LoadMore();
  });

})(); // End of IIFE